export default __webpack_public_path__ + "static/Linking-Park-d94c643ab4740fd63cb3422fb0f99b78.png";